// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19841":"31a803c6","31206":"c25e2be9","37388":"0d49ff13","38563":"447594ff","56430":"26668ece","59041":"26668ece","82368":"0065849d","89199":"26668ece","93067":"26668ece","93891":"1e08287f"}[chunkId] + ".chunk.css";
};